$(document).ready(function() {

    // Search Button Click Start
    $('.header__icon--search').click(function() {
        $('body').addClass('overflow-hidden')
    });
    $('.search-modal__close-button').click(function() {
        $('body').removeClass('overflow-hidden')
    });
    // Search Button Click End

    // Search Input Start
    $('.search__modal-top .search__input').keyup(function() {
        var searchVal = $(this).val().length;
        if (searchVal >= 1) {
            $(this).parents('.search-modal').find('.search-megamenu__wrapper').hide();
            $(this).parents('.search-modal').removeClass('search_megamenu--show');
        } else {
            $(this).parents('.search-modal').find('.search-megamenu__wrapper').show();
            $(this).parents('.search-modal').addClass('search_megamenu--show');
        }
    });
    $(document).on('click', '.search__modal-top .reset__button', function() {
        $(this).parents('.search-modal').addClass('search_megamenu--show');
        $(this).parents('.search-modal').find('.search-megamenu__wrapper').show();
    });
    // Search Input End

    // How to step by step modal
    $('.step-content a').click(function() {
        $('body').addClass('how-to-modal-open');
    });
    $('.how-to-step-modal-close,.modal-backdrop').click(function() {
        $('body').removeClass('how-to-modal-open');
    });

    // Tips & Tricks Modal
    $('.tips-content a').click(function() {
        $('body').addClass('modal-open');
    });
    $('.trick-modal-close,.modal-backdrop').click(function() {
        $('body').removeClass('modal-open');
    });

    // Country Dropdown start
    $(".country-dropdown-selector").on("click", function(event) {
        event.stopPropagation();
        $(this).parents('.country-dropdown').find('ul').slideToggle();
    });

    $(document).on('click', function(event) {
        if (!$(event.target).closest('.country-dropdown-selector').length) {
            $('.country-dropdown').find('ul').slideUp();
        }
    });
    // Country Dropdown End

    // Hero Banner Video Start
    let vid = document.getElementById("myVideo");
    $('.pause-btn').click(function() {
        vid.pause();
        $(this).hide();
        $(this).parent('.play-pause-btn').find('.play-btn').show();
    });
    $('.play-btn').click(function() {
        vid.play();
        $(this).hide();
        $(this).parent('.play-pause-btn').find('.pause-btn').show();
    });
    $('.mute-button').click(function() {
        $("video").prop('muted', false);
        $(this).hide();
        $(this).parent('.mute-btn').find('.unmute-btn').show();
    });
    $('.unmute-btn').click(function() {
        $("video").prop('muted', true);
        $(this).hide();
        $(this).parent('.mute-btn').find('.mute-button').show();
    });
    // Hero Banner Video End

    // Footer Accordian Start
    if ($(window).width() < 768) {
        $('.footer-menu h6').click(function() {
            if ($(this).hasClass("active")) {
                $(this).removeClass("active").parents('.footer-menu').find('ul').slideUp();
            } else {
                $(".footer-menu h6.active").next().slideUp();
                $(".footer-menu h6.active").removeClass("active");
                $(this).addClass("active").parents('.footer-menu').find('ul').slideDown();
            }
            return false;
        });
    }
    // Footer Accordian End

    // Product Tab Start
    // $('.quantity-tab li').click(function() {
    //     var tab_id = $(this).attr('data-tab');
    //     $('.quantity-tab li').removeClass('current');
    //     $('.tab-button').removeClass('current');
    //     $(this).addClass('current');
    //     $("#" + tab_id).addClass('current');
    // });
    // Product Tab End

    // Product Info FAQ Start
    $(document).on('click', '.product-detail-wrapper h6', function() {
        $(this).next().slideToggle();
        $(this).toggleClass('active')
    });
    // Product Info FAQ End

    // Product Tab Video Popup Start
    Fancybox.bind("[data-fancybox]", {
        // Your custom options
    });
    // Product Tab Video Popup End

    // Product Page Discount Table Start
    $(document).on('click', '.product-discount-wrapper h3', function() {
        $(this).next().slideToggle();
        $(this).toggleClass('active');
    });
    // Product Page Discount Table End

    // Product Page Main Gallery Slider Start

    var $slider = $('.mobile-product-slider');
    var $progressBar = $('.mobile-product-slider-progress');
    $slider.on('init', function(event, slick) {
        var slideCount = $('.mobile-product-slider .product__media-item').length;
        var calc = (1 / (slideCount)) * 100;

        $progressBar
            .css('background-size', calc + '% 100%')
            .attr('aria-valuenow', calc);
    });

    $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        var calc = ((nextSlide + 1) / (slick.slideCount)) * 100;

        $progressBar
            .css('background-size', calc + '% 100%')
            .attr('aria-valuenow', calc);
    });

    $slider.slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
    });
    // Product Page Main Gallery Slider End

    // Size Chart Modal Start
    setTimeout(function() {
        $(document).on('click', '.size_pop', function() {
            $("body").toggleClass("size_chart_open");
        });
    }, 3000);
    $(".sizechart_close_btn").click(function() {
        $("body").removeClass("size_chart_open");
    });
    // Size Chart Modal End

    // Collection Page Navigation Filter Show Start
    $(document).on('click', '.desk-filter-btn', function() {
        $(this).toggleClass('expand-filter');
        $('.product-grid-container').toggleClass('show-filter');

    });
    // Collection Page Navigation Filter Show End

    //FAQ page Accordian Start
    $('.faq-heading').click(function(e) {
        e.preventDefault();
        let $this = $(this);
        if ($this.next().hasClass('show')) {
            $this.next().slideUp(350);
            $this.next().removeClass('show');
            $this.removeClass('active-accordian');
        } else {
            $this.parent().parent().find('.faq-answer').removeClass('show');
            $('.faq-heading').removeClass('active-accordian');
            $this.parent().parent().find('.faq-answer').slideUp(350);
            $this.next().toggleClass('show');
            $this.next().slideToggle(350);
            $this.toggleClass('active-accordian');
        }
    });
    //FAQ page Accordian End

    // FAQ page live search Start
    $("#filter").keyup(function() {
        // Retrieve the input field text and reset the count to zero
        var filter = $(this).val();
        // Loop through the comment list
        $(".faq-content-wrapper .faq-accordian").each(function() {
            // If the list item does not contain the text phrase fade it out
            if ($(this).text().search(new RegExp(filter, "i")) < 0) {
                $(this).fadeOut();
                // Show the list item if the phrase matches and increase the count by 1
            } else {
                $(this).show();
            }
        });
    });
    // FAQ page live search End

    // How to Customize page view more Start
    // $(window).on("resize", function(event) {
    //     if ($(window).width() <= 767) {
    //         var $this = $('.produ-offer--sec');
    //         if ($this.find('.offer--box').length > 2) {
    //             $('.proud-offer--wrapper .showMore').show()
    //         } else {
    //             $('.proud-offer--wrapper .showMore').hide()
    //         }
    //         // If more than 2 Education items, hide the remaining
    //         $('.produ-offer--sec .offer--box').slice(0, 4).addClass('shown');
    //         $('.produ-offer--sec .offer--box').not('.shown').hide();
    //         $('.proud-offer--wrapper .showMore').on('click', function() {
    //             $('.produ-offer--sec .offer--box').not('.shown').toggle(300);
    //             $(this).toggleClass('showLess');
    //         });
    //     } else {
    //         $('.produ-offer--sec .offer--box').slice(0, 4).removeClass('shown');
    //         $('.produ-offer--sec .offer--box').not('.shown').show();
    //     }
    // });
    $(document).ready(function() {
        if ($(window).width() <= 767) {
            var $this = $('.produ-offer--sec');
            if ($this.find('.offer--box').length > 2) {
                $('.proud-offer--wrapper .showMore').show()
            } else {
                $('.proud-offer--wrapper .showMore').hide()
            }
            // If more than 2 Education items, hide the remaining
            $('.produ-offer--sec .offer--box').slice(0, 4).addClass('shown');
            $('.produ-offer--sec .offer--box').not('.shown').hide();
            $('.proud-offer--wrapper .showMore').on('click', function() {
                $('.produ-offer--sec .offer--box').not('.shown').toggle(300);
                $(this).toggleClass('showLess');
            });
        } else {
            $('.produ-offer--sec .offer--box').slice(0, 4).removeClass('shown');
            $('.produ-offer--sec .offer--box').not('.shown').show();
        }
    });
    // How to Customize page view more End

    // Premium Digitization product checkbox click start
    $('input#confirm_check').click(function() {
        if ($(this).prop("checked") == true) {
            $('button.add-cart-custom').prop('disabled', false);
        } else if ($(this).prop("checked") == false) {
            $('button.add-cart-custom').prop('disabled', true);
        }
    });
    // Premium Digitization product checkbox click end

    setTimeout(function() {
        if ($('input#confirm_check').prop("checked") == true) {
            $('button.add-cart-custom').prop('disabled', false);
        } else if ($('input#confirm_check').prop("checked") == false) {
            $('button.add-cart-custom').prop('disabled', true);
        }
    }, 2000);

    // Premium Digitization Product Inspiration Slider start
    $('.desc-gallery-slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: $('.swiper-button-prev'),
        nextArrow: $('.swiper-button-next')
    });
    // Premium Digitization Product Inspiration Slider End

    $(document).on("click", ".quantity-tab li", function () {
        var tab_id = $(this).attr("data-tab");
        var $form = $(".product-form-btn .product-form-blank form");
        $(".quantity-tab li").removeClass("current");
        $(this).addClass("current");
        if (tab_id == "customize-me") {
        $(".product-form-btn").addClass("customize");
        $(".customize-digitized-wrapper").removeClass("hidden");
        } else {
        $(".product-form-btn").removeClass("customize");
        $(".customize-digitized-wrapper").addClass("hidden");
        }
        if (tab_id == "purchase-blank") {
        $(".product-form-btn").addClass("purchase-blank");
        if ($form.length) {
            var $input = $("<input>", {
            type: "hidden",
            name: "properties[_product_type]",
            value: "blank",
            });
            // Append it to the form
            $form.append($input);
        }
        } else {
            $form.find('input[name="properties[_product_type]"]').remove();
            $(".product-form-btn").removeClass("purchase-blank");
        }
        if (tab_id == "purchase-patch") {
            $(".patches-block-info").removeClass("hidden");
            $(".pxf-dst-file-upload-block").addClass("hidden");
            $(".customize_wrapper").addClass("hidden");
            $(".customize_wrapper-btn-errors").addClass("hidden");
            $(".tips-tracks--wrapper").addClass("hidden");
            $(".product-discount-info").addClass("hidden");
        } else if (tab_id == "pxf-dst-file-upload") {
            $(".pxf-dst-file-upload-block").removeClass("hidden");
            $(".patches-block-info").addClass("hidden");
            $(".customize_wrapper").addClass("hidden");
            $(".customize_wrapper-btn-errors").addClass("hidden");
            $(".tips-tracks--wrapper").addClass("hidden");
            $(".product-discount-info").addClass("hidden");
        } else {
            $(".patches-block-info").addClass("hidden");
            $(".pxf-dst-file-upload-block").addClass("hidden");
            $(".customize_wrapper").removeClass("hidden");
            $(".customize_wrapper-btn-errors").removeClass("hidden");
            $(".tips-tracks--wrapper").removeClass("hidden");
            $(".product-discount-info").removeClass("hidden");
        }
    });

    // Cart Page Jump the line start
    //get the cart
    let cart = $.getJSON('/cart.js');
    // wait for the response
    cart.done(function() {
        //when you have the response, get the JSON and set items to cart.items
        cart = cart.responseJSON;

        let items = cart.items;
        console.log('cart', items);
        let count = cart.item_count;
        // make a boolean to make sure that the item you want to add isnt already in the cart (to keep the JS from firing again on page reload)
        let item_in_cart_already = false;
        // product we are checking to see is in the cart
        let item_in_cart_prod_id = 6805410250944;
        // the product we want to add's product id
        let item_to_add_prod_id = 7767497310400;
        // the product we want to add's variant id
        let item_to_add_variant_id = 44718815281344;
        let productCount = 0;
        //check the cart items and set boolean to true if the item is in the cart
        for (var i = 0; i < items.length; i++) {
            if (items[i].product_id == item_in_cart_prod_id) {
                item_in_cart_already = true;
            } else {
                productCount++;
            }
        }

        let jumpPro = $('.cart-items').find('[data-product-id="' + item_to_add_prod_id + '"]').length;
        if (item_in_cart_already && count == 1) {
            $('body').addClass('disabled-jump-the-line');
            $('.cart__upsell-info button.def-btn').attr('disabled', true);
            if (jumpPro > 0) {
                removeItemFromCart(item_to_add_variant_id);
            }
        } else if (item_in_cart_already && count >= 2) {
            $('body').addClass('disabled-jump-the-line');
            if (productCount < 2 && jumpPro > 0) {
                if (jumpPro > 0) {
                    removeItemFromCart(item_to_add_variant_id);
                }
            } else if (item_in_cart_already && productCount < 1) {
                $('body').addClass('disabled-jump-the-line');
            } else {
                $('body').removeClass('disabled-jump-the-line');
            }
        } else {
            $('body').removeClass('disabled-jump-the-line');
            $('.cart__upsell-info button.def-btn').attr('disabled', false);
        }
    });
    // Cart Page Jump the line End

});

// Shop Brand Slider Start
var antbase;
! function($) {
    "use strict";
    antbase = function() {
        var basetheme = {
            popupEffect: "",
            supports_html5_storage: !1,
            ajaxLinks: ""
        };
        try {
            basetheme.supports_html5_storage = "sessionStorage" in window && null !== window.sessionStorage, window.sessionStorage.setItem("theme", "test"), window.sessionStorage.removeItem("theme")
        } catch (e) {
            basetheme.supports_html5_storage = !1
        }
        return {
            init: function() {
                this.recommendations();
                this.instagram();
                this.service();
                this.inspirationGallery();
            },
            recommendations: function() {
                var $slider = $('.brand-slider');
                var $progressBar = $('.progress');
                $slider.on('init', function(event, slick) {
                    var slideCount = $('.brand-slider .shop-brand-box').length;
                    var calc = (1 / (slideCount)) * 100;

                    $progressBar
                        .css('background-size', calc + '% 100%')
                        .attr('aria-valuenow', calc);
                });

                $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
                    var calc = ((nextSlide + 1) / (slick.slideCount)) * 100;

                    $progressBar
                        .css('background-size', calc + '% 100%')
                        .attr('aria-valuenow', calc);
                });

                    $slider.slick({
                        infinite: true,   
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        prevArrow: $('.slick-button-prev'),
                        nextArrow: $('.slick-button-next'),

                        responsive: [
                            {
                                breakpoint: 992,
                                settings: {
                                    slidesToShow: 2
                                }
                            },
                         {
                                breakpoint: 768,
                                settings: {
                                    slidesToShow: 2,
                                    infinite: false   
                                }
                            }
                
                        ]
                    });
            },
            instagram: function() {
                $('.insta-box-wrapper').slick({
                    infinite: true,
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    arrows: false,
                    dots: false,
                    responsive: [{
                            breakpoint: 400,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                centerMode: true,
                                centerPadding: '70.5px',
                            }
                        }, {
                            breakpoint: 481,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                centerMode: true,
                                centerPadding: '97.5px',
                            }
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2,
                            }
                        }

                    ]
                })
            },
            service: function() {
                $('.newsletter-service').removeClass('hidden');
                $('.newsletter-service').slick({
                    speed: 5000,
                    autoplay: true,
                    autoplaySpeed: 0,
                    cssEase: 'linear',
                    slidesToShow: 7,
                    slidesToScroll: 1,
                    variableWidth: true,
                    arrows: false,
                    infinite: true,
                    pauseOnHover: false,
                    responsive: [{
                            breakpoint: 750,
                            settings: {
                                slidesToShow: 3,
                            }
                        },
                        {
                            breakpoint: 480,
                            settings: {
                                slidesToShow: 2,
                            }
                        }
                    ]
                })
            },
            inspirationGallery: function() {
                var $slider = $('.inspiration-gallery-img');
                var $progressBar = $('.progress');
                $slider.on('init', function(event, slick) {
                    var slideCount = $('.inspiration-gallery-img .inspiration-img-info').length;
                    var calc = (1 / (slideCount)) * 100;

                    $progressBar
                        .css('background-size', calc + '% 100%')
                        .attr('aria-valuenow', calc);
                });

                $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
                    var calc = ((nextSlide + 1) / (slick.slideCount)) * 100;

                    $progressBar
                        .css('background-size', calc + '% 100%')
                        .attr('aria-valuenow', calc);
                });

                $slider.slick({
                    infinite: true,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    prevArrow: $('.slick-button-prev'),
                    nextArrow: $('.slick-button-next'),
                    responsive: [{
                            breakpoint: 992,
                            settings: {
                                slidesToShow: 2,
                            }
                        },
                        {
                            breakpoint: 481,
                            settings: {
                                slidesToShow: 2,
                            }
                        }
                    ]
                });
            }

        }
    }()
}
(jQuery),
jQuery(document).ready(function() {
        antbase.init()
    }),
    jQuery(document).on("shopify:section:load", antbase.recommendations).on("shopify:section:unload", antbase.recommendations).on("shopify:section:select", antbase.recommendations).on("shopify:section:deselect", antbase.recommendations).on("shopify:block:select", antbase.recommendations).on("shopify:block:deselect", antbase.recommendations);
jQuery(document).on("shopify:section:load", antbase.instagram).on("shopify:section:unload", antbase.instagram).on("shopify:section:select", antbase.instagram).on("shopify:section:deselect", antbase.instagram).on("shopify:block:select", antbase.instagram).on("shopify:block:deselect", antbase.instagram);
jQuery(document).on("shopify:section:load", antbase.service).on("shopify:section:unload", antbase.service).on("shopify:section:select", antbase.service).on("shopify:section:deselect", antbase.service).on("shopify:block:select", antbase.service).on("shopify:block:deselect", antbase.service);
jQuery(document).on("shopify:section:load", antbase.inspirationGallery).on("shopify:section:unload", antbase.inspirationGallery).on("shopify:section:select", antbase.inspirationGallery).on("shopify:section:deselect", antbase.inspirationGallery).on("shopify:block:select", antbase.inspirationGallery).on("shopify:block:deselect", antbase.inspirationGallery);
// Shop Brand Slider End


// Enter Event None Start
$(window).ready(function() {
    $("#filter").on("keypress", function(event) {
        var keyPressed = event.keyCode || event.which;
        if (keyPressed === 13) {
            event.preventDefault();
            return false;
        }
    });
});
// Enter Event None End


// Custom Add to Cart button Start
const $sample_atc_submit_event = async function($form_data) {
    const $sample_addtocart_result = await fetch('/cart/add.json', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify($form_data)
    });
    const $atc_success_result = await $sample_addtocart_result.json();
    if ($atc_success_result.items) {
        if (document.querySelector('cart-drawer') && document.querySelector('cart-drawer').classList.contains('is-empty')) document.querySelector('cart-drawer').classList.remove('is-empty');
        const quickAddModal = document.querySelector('quick-add-modal');
        if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
                setTimeout(() => { document.querySelector('cart-drawer').renderContents($atc_success_result) });
            }, { once: true });
            quickAddModal.hide(true);
        } else {
            document.querySelector('cart-drawer').renderContents($atc_success_result);
            collectionSlider('.cart_drawer--collection-box--wrapper');
            if (typeof initCartDrawerSlider === 'function') {
                setTimeout(initCartDrawerSlider, 300);
            }
        }
    } else {
        console.error($atc_success_result);
    }
}
$(document).on('click', '.drawer__colleciton-info button', function(e) {
    e.preventDefault(), e.stopImmediatePropagation();
    let sample_product_atc_array = [];
    sample_product_atc_array.push({
        id: $(this).attr("data-val"),
        quantity: 1
    });
    let sample_product_atc_formData = { items: sample_product_atc_array, sections_url: window.location.pathname, sections: document.querySelector('cart-drawer').getSectionsToRender().map((section) => section.id) };
    $sample_atc_submit_event(sample_product_atc_formData);
});
// Custom Add to Cart button End

$(document).on('click', '.cart-drawer__overlay', function(e) {
    $(".drawer__close").trigger("click");
 });

function updateCart() {
    fetch(window.Shopify.routes.root + '?section_id=cart-drawer').then((response) => response.text()).then((responseText) => {
        const cartid = 'CartDrawer';
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.querySelector('#CartDrawer');
        const source = html.getElementById(cartid);
        if (source && destination) { 
            destination.innerHTML = source.innerHTML;
            // Re-initialize the cart drawer collection slider after HTML is replaced
            document.dispatchEvent(new CustomEvent('cart:updated'));
        }
        $.ajax({
            url: '/?section_id=cart-icon-bubble',
            type: 'GET',
            dataType: 'html',
            success: function (itemcount) {
                $("#cart-icon-bubble").html($(itemcount).html());
                $(".cart-count-bubble").trigger("click");
                console.log('cart updated');
            }
        });
    });
}




// Patch size pop-up modal
$(document).ready(function () {
  // Initialize each slider individually
  $('.patch-height-modal-content-row').each(function () {
    const $slider = $(this);

    $slider.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: false,
      autoplay: false,
      dots: false,
      arrows: true,
      prevArrow: $slider.closest('.patch-height-modal-content-slider').find('.prev-btn'),
      nextArrow: $slider.closest('.patch-height-modal-content-slider').find('.next-btn'),
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 750,
          settings: "unslick"
        },
      ],
    });
  });

  // Handle nav click for tab switching
  $('.patch-height-modal-nav li').on('click', function () {
    const $this = $(this);
    const target = $this.data('tab'); // Example: "patch-1"

    // Remove active from all nav items
    $('.patch-height-modal-nav li').removeClass('active');
    $this.addClass('active');

    // Hide all sliders and show the selected one
    $('.patch-height-modal-content-slider').removeClass('active').hide();
    $('#' + target).addClass('active').fadeIn();

    // Reset slick position for visible slider
    $('#' + target).find('.patch-height-modal-content-row').slick('setPosition').slick('slickGoTo', 0); // optional: reset to first slide
  });
});

